import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PartyPopper } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Switch } from "@/components/ui/switch";

export const OverlayHolidayToggle = ({ overlay }) => {
  const { t, lang } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/holiday/overlay").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const set = async (on) => {
    setD({ ...d, on });
    try { const r = await api.put("/holiday/overlay", { on }); setD(r.data); toast.success(t(on ? "hol.ov_on" : "hol.ov_off")); }
    catch (e) { setD(d); toast.error(formatApiError(e)); }
  };
  const cur = d.current;
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2.5 mt-2" data-testid="overlay-holiday-toggle-box">
      <div className="flex items-center gap-2.5">
        <PartyPopper className="w-4 h-4 text-[#ff9df0]" />
        <span className="text-xs text-slate-200 flex-1">{t("hol.ov_label")}</span>
        <Switch checked={d.on} onCheckedChange={set} data-testid="overlay-holiday-toggle" />
      </div>
      <p className="text-[11px] text-slate-500 mt-1.5" data-testid="overlay-holiday-status">
        {cur ? t("hol.ov_now", { n: lang === "fr" ? cur.fr : cur.en }) : t("hol.ov_none")}
        {cur && <> · <a href={`${overlay}?holiday_preview=${cur.id}`} target="_blank" rel="noreferrer" className="text-[#ff9df0] hover:underline" data-testid="overlay-holiday-preview">{t("hol.ov_preview")}</a></>}
      </p>
    </div>
  );
};
